import axios from 'axios';
import { API_URLS } from './Constants/apiUrl'; 

// export const schoolOnboarding = (formData) => {
//   return axios.post(
//    'http://45.113.226.131:82/api/AdminDashboard/Create/SchoolOnboarding',
//     formData,
//     {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//       },
//     }
//   );
// };

export const schoolOnboarding = async (formData) => {
  const response = await axios.post(
    'http://testapi.violetsync.com/api/AdminDashboard/Create/SchoolOnboarding',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return response.data; 
};
